import React, { useEffect, useState, useRef } from "react";
import PayrollNavData from "../data/PayrollNavData";
import * as SectionComponents from "../components/sections"; // Import all components scrollToSection 

const FixedLayout = ({ country }) => {
 
  
  const [activeTab, setActiveTab] = useState(PayrollNavData[0].id); // Default to the first section
  
  const sectionRefs = useRef(
    PayrollNavData.reduce((refs, section) => {
      refs[section.id] = React.createRef();
      return refs;
    }, {})
  ).current;

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveTab(entry.target.id);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: 0 }
    );

    Object.values(sectionRefs).forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => observer.disconnect();
  }, [sectionRefs]);

 

  const scrollToSection = (sectionId) => {
    const section = sectionRefs[sectionId].current;
    if (section) {
      section.scrollIntoView({ behavior: "smooth"});
      setActiveTab(sectionId);
    }
  };

  // Helper to sanitize section names for mapping to components
  const getComponentName = (name) => name.replace(/&/g, "And").replace(/\s/g, "");
  return (
    <div className="container">
      {/* Sidebar Navigation */}
      <div className="fixed-tabs-container">
      <nav className="fixed-tabs">
        <ul>
          {PayrollNavData.map((section) => (
            <li
              key={section.id}
              className={`tab-button ${activeTab} ${section.id} ${activeTab === section.id ? "active" : ""}`}
              onClick={() => scrollToSection(section.id)}
            >
              {section.name}
            </li>
          ))}
        </ul>
      </nav>

      {/* Render Sections with Associated Components */}
      <div className="scrollable-content">
        {PayrollNavData.map((section) => {
          const ComponentName = getComponentName(section.name); // Sanitize name
          const SectionComponent = SectionComponents[ComponentName];
          return (
            <section
              key={section.id}
              id={section.id}
              ref={sectionRefs[section.id]}
              className="content-section"
            >
              {SectionComponent ? (
                <SectionComponent country={country}  />
              ) : (
                <p>Component not found for {section.name}</p>
              )}
            </section>
          );
        })}
      </div>
      </div>
    </div>
  );
};

export default FixedLayout;
